export default "__VITE_ASSET__BjTa7ymM__"